import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  fill: "none",
  viewBox: "0 0 16 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#FF5C35\" d=\"M0 15.334V23h7.584c0-4.234-3.396-7.666-7.584-7.666\"></path><path fill=\"#B12028\" d=\"M15.168 15.334V23H7.584c0-4.234 3.396-7.666 7.584-7.666\"></path><path fill=\"#FF5C35\" d=\"M15.168 15.334V7.667H7.584c0 4.233 3.395 7.666 7.584 7.666\"></path><path fill=\"#F88D2A\" d=\"M0 15.334V7.667h7.584c0 4.233-3.396 7.666-7.584 7.666\"></path><path fill=\"#FFB548\" d=\"M0 0v7.666h7.584C7.584 3.433 4.188 0 0 0\"></path><path fill=\"#E43D30\" d=\"M15.168 0v7.666H7.584C7.584 3.433 10.979 0 15.168 0\"></path>", 6)
  ])))
}
export default { render: render }